import { render } from "./D_contBoxMemo.vue?vue&type=template&id=f9abe0e2&scoped=true"
import script from "./D_contBoxMemo.vue?vue&type=script&lang=js"
export * from "./D_contBoxMemo.vue?vue&type=script&lang=js"

import "./D_contBoxMemo.vue?vue&type=style&index=0&id=f9abe0e2&scoped=true&lang=css"

import exportComponent from "C:\\Users\\SAEUM\\Desktop\\teampl-project\\github\\unibuzzy\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f9abe0e2"]])

export default __exports__